import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
const toFormDefinition = ({ fields, formStyle, }) => {
    var _a;
    return ({
        institutionAcronym: fields.institutionAcronym,
        active: true,
        headline: fields.headline,
        title: fields.title,
        subtitle: fields.subtitle,
        fields: fields.formFields.map((field, index) => {
            var _a, _b, _c;
            return (Object.assign(Object.assign({}, field), { id: (_a = field.id) !== null && _a !== void 0 ? _a : -index, formFieldPosition: index, fieldLabel: (_b = field.fieldLabel) !== null && _b !== void 0 ? _b : "", required: (_c = field.required) !== null && _c !== void 0 ? _c : false }));
        }),
        formStyle: Object.assign(Object.assign({}, formStyle), { fontFamily: (_a = formStyle.fontFamily) === null || _a === void 0 ? void 0 : _a.value }),
    });
};
export const PREVIEW_IFRAME_DEFAULT_HEIGHT = 600;
// This calculation is based on the height of the viewport, minus primary navbar height (watermark bar + navigation bar),
// minus secondary navbar height, minus mb-3. This makes it so the iframe preview always stay contained in the screen
export const PREVIEW_IFRAME_MAX_HEIGHT = "calc(100vh - 70px - 70px - 40px - 1rem)";
const FormPreview = ({ state }) => {
    if (!state.fields.institutionAcronym) {
        return null;
    }
    return (_jsx(_Fragment, { children: _jsx("sse-form", { submittable: "false", "form-definition": JSON.stringify(toFormDefinition(state)), "use-waf": "false" }) }));
};
export default FormPreview;
